module.exports = __webpack_public_path__ + "img/expense_type_definition.1f134677.png";